import { defineStore } from 'pinia'

const useOrderStore = defineStore('order', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useOrderStore
